import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FocusManagerService {

  constructor() { }

  public pushFocus(area: string) {
    this.focusStack.push(area);
  }

  public popFocus(area: string) {
    setTimeout(() => {
      if (this.focusStack[this.focusStack.length - 1] != area) {
        return;
      }
      this.focusStack.pop();
    }, 100);
  }

  public getFocusArea() {
    return this.focusStack[this.focusStack.length - 1];
  }


  public resetStack() {
    this.focusStack = ["base"];
  }
  private focusStack: string[] = ["base"];
}
